import api from './api';
import { API_ENDPOINTS } from '../constants';

export interface PromocodeTemplate {
  id: number;
  name: string;
  type: 'image' | 'video';
  file?: {
    path?: string;
    url?: string;
    mime_type: string;
  };
  thumbnail?: {
    path: string;
  };
  data?: any;
  categories?: {id: number; name: string;}[] | null;
  categoryId?: number;
  // category?: {id: number; name: string;} | null
  user?: {
    id: number;
    name: string;
  };
  hasCoords?: () => boolean;
}

/** Ответ API GET /api/v1/admin/templates (список с пагинацией) */
export interface TemplateListResponse {
  items: TemplateApiItem[];
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

/** Элемент шаблона в ответе API */
export interface TemplateApiItem {
  id: number;
  name: string;
  x: number;
  y: number;
  width: number;
  height: number;
  textColor: string;
  rotationAngle: number;
  startTimeSeconds: number;
  endTimeSeconds: number;
  // categories?: any[];
  // categoryId?: number;
  categories: {id: number; name: string;}[] | null
  user?: { id: number; userName: string; role?: { id: number; name: string } };
  file?: { id: number; path?: string; url?: string; contentType?: string; originalFileName?: string };
  font?: { id: number; name: string; file?: { path: string } };
}

export interface PromocodeTemplateUpdatePayload {
  name: string;
  file?: File;
  x: number;
  y: number;
  width: number;
  height: number;
  fontId: number;
  fontSize?: number;
  textColor: string;
  rotationAngle: number;
  startTimeSeconds: number;
  endTimeSeconds: number;
  categoryId:  number[];
}

export interface PromocodeTemplateCreateData extends PromocodeTemplateUpdatePayload {}

function buildTemplateFormData(data: PromocodeTemplateUpdatePayload): FormData {
  const form = new FormData();
  if (data.file) form.append('File', data.file);

  form.append('Name', data.name);
  form.append('Width', String(data.width));
  form.append('Height', String(data.height));
  form.append('X', String(data.x));
  form.append('Y', String(data.y));
  form.append('FontId', String(data.fontId));
  form.append('TextColor', data.textColor);
  form.append('RotationAngle', String(data.rotationAngle));
  form.append('StartTimeSeconds', String(data.startTimeSeconds));
  form.append('EndTimeSeconds', String(data.endTimeSeconds));
  // const categoryId = Array.isArray(data.categoryId) ? data.categoryId[0] : data.categoryId;
  // form.append('CategoryId', String(categoryId));
  
  data.categoryId.forEach((id) => form.append('CategoryIds', String(id)));
  return form;
}

function mapApiItemToTemplate(item: TemplateApiItem): PromocodeTemplate {
  const isVideo = item.file?.contentType?.startsWith('video/') ?? false;
  console.log(item);
  return {
    id: item.id,
    name: item.name,
    type: isVideo ? 'video' : 'image',
    categories: item.categories ? item.categories : null,
    // categoryId: item.categoryId,
    // category: item.category || null,
    file: item.file ? { path: item.file.path, url: item.file.url, mime_type: item.file.contentType || 'image/*' } : undefined,
    user: item.user ? { id: item.user.id, name: item.user.userName } : undefined,
    data: {
      x: item.x,
      y: item.y,
      width: item.width,
      height: item.height,
      fontId: item.font?.id,
      textColor: item.textColor,
      rotationAngle: item.rotationAngle,
      startTimeSeconds: item.startTimeSeconds,
      endTimeSeconds: item.endTimeSeconds,
    },
  };
}

export const promocodeTemplateService = {
  /** GET /api/v1/admin/templates — список шаблонов с пагинацией */
  getTemplates: async (categoryId?: string | null, page: number = 1, limit: number = 10): Promise<{
    data: PromocodeTemplate[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  }> => {

    const params = {
      categoryId, page, limit
    }
    const { data } = await api.get<TemplateListResponse>(API_ENDPOINTS.TEMPLATES, {
      params: params,
    });
    const items = (data.items || []).map(mapApiItemToTemplate);
    return {
      data: items,
      current_page: data.page,
      last_page: data.totalPages,
      per_page: data.pageSize,
      total: data.totalCount,
    };
  },

  /** GET /api/v1/admin/templates/{id} — шаблон по id */
  getTemplate: async (id: number): Promise<PromocodeTemplate> => {
    const { data } = await api.get<TemplateApiItem>(API_ENDPOINTS.TEMPLATE(id));
    return mapApiItemToTemplate(data);
  },

  createTemplate: async (data: PromocodeTemplateCreateData) => {
    const form = buildTemplateFormData(data);
    const { data: result } = await api.post(API_ENDPOINTS.TEMPLATES, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return result;
  },

  updateTemplate: async (id: number, data: PromocodeTemplateUpdatePayload) => {
    const form = buildTemplateFormData(data);
    const { data: result } = await api.patch(API_ENDPOINTS.TEMPLATE(id), form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return result;
  },

  /** DELETE /api/v1/admin/templates/{id} */
  deleteTemplate: async (id: number) => {
    await api.delete(API_ENDPOINTS.TEMPLATE(id));
  },

  testTemplate: async (_id: number, text: string) => {
    await new Promise((r) => setTimeout(r, 200));
    return { result: `mock result for: ${text}` };
  },
};
